import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { handleErrors } from "../../../services/dataManager";
import { fetchHighValueUsers } from "../../../services/axios/apiManager";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import BSPagination from "../../../Components/pagination";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function TopUsersByAdViews() {
  const tableRef = useRef(null);
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({});

  const getHighValueUsers = async (
    page = pagination?.currentPage || 1,
    pageSize = pagination?.pageSize || 10
  ) => {
    const res = await fetchHighValueUsers(page, pageSize);
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      setPagination(res?.data?.metadata || {});
      // if (userType) {
      //   const temp = res?.data?.data?.filter((f) => f.user_type === userType);
      //   setFilteredData(temp);
      // } else {
      //   setFilteredData(res.data.data);
      // }
    } else {
      handleErrors(res, navigate);
    }
  };

  const handlePageChange = async (page) => {
    await getHighValueUsers(page, pagination.pageSize || 10);
  };
  // const handleFilterChange = (e) => {
  //    setUserType(e.target.value);
  //   if (e.target.value) {
  //     const temp = tableData?.filter((f) => f.user_type === e.target.value);
  //     setFilteredData(temp);
  //   } else {
  //     setFilteredData(tableData);
  //   }
  // };

  // const handleReset = () => {
  //   setUserType("");
  // };

  // Chart data: one bar per user, color-coded by userType
  const chartData = {
    labels: tableData.map(
      (item) => `${item.first_name || ""} ${item.username || ""}`
    ),
    datasets: [
      {
        label: "Ad Views",
        data: tableData.map((item) => item.total_ads),
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        // backgroundColor: filteredData.map((item) =>
        //   item.userType === "Guest"
        //     ? "rgba(255, 99, 132, 0.6)"
        //     : "rgba(54, 162, 235, 0.6)"
        // ),
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.parsed.y} views`,
        },
      },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: {
        beginAtZero: true,
        ticks: { color: "#ffffff" },
      },
    },
  };

  useEffect(() => {
    getHighValueUsers();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = tableData.map((item) => {
      return [
        `${item.first_name || ""} ${item.last_name || ""}`,
        item.total_ads,
      ];
    });

    const config = {
      data: rows,
      columns: [{ title: "Name" }, { title: "Ad Views" }],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [tableData]);

  return (
    <DashboardLayout>
      {/* Filter Card */}
      {/* <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by User Type</h5>
          <div className="row align-items-center mb-3">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={userType}
                onChange={handleFilterChange}
              >
                <option value="">All user types</option>
                <option value="Guest">Guest</option>
                <option value="Registered">Registered</option>
              </Form.Select>
            </div>
            <div className="col-md-2">
              <Button variant="success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div> */}

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Top Users by Ad Views</h5>
          <p className="card-text">
            Identify high-value users who engage with ads frequently.
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            <div className="constainer-fluid mt-2">
              <div className="d-flex justify-content-end">
                <div className="mx-4 py-2">
                  <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
                </div>
                <BSPagination
                  currentPage={parseInt(pagination?.currentPage)}
                  totalPages={parseInt(pagination?.totalPages)}
                  onPageChange={handlePageChange}
                  siblingCount={2}
                  showFirstLast={true}
                />
              </div>
            </div>

            {/* <Table className="table-hover table-striped align-middle table-borderless table-dark mb-0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Ad Views</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{`${item.first_name || ""} ${item.last_name || ""}`}</td>
                    <td>{item.total_ads}</td>
                  </tr>
                ))}
              </tbody>
            </Table> */}
            {tableData.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Ad Views by User</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default TopUsersByAdViews;
